import { isBrandAC, isBrandAP, isBrandDS, isBrandOV } from '../../constants/main';
import { PaginatorStyledAC } from './AC/PaginatorStyled.AC';
import { PaginatorStyledAP } from './AP/PaginatorStyled.AP';
import { PaginatorStyledDS } from './DS/PaginatorStyled.DS';
import { PaginatorStyledOV } from './OV/PaginatorStyled.OV';
import { PaginatorStyled } from './PaginatorStyled';
import { SC } from '../../styles/theme';
import React from 'react';

export interface IPaginatorProps extends SC {
    total: number;
    handlePageClick: (event: IPaginatorPage) => void;
    page: number;
    perPage: number;
}

export interface IPaginatorPage {
    selected: number;
}

const Paginator = (props: IPaginatorProps) => {
    if (isBrandAC) return <PaginatorStyledAC {...props} />;
    if (isBrandOV) return <PaginatorStyledOV {...props} />;
    if (isBrandAP) return <PaginatorStyledAP {...props} />;
    if (isBrandDS) return <PaginatorStyledDS {...props} />;
    return <PaginatorStyled {...props} />;
};

export default Paginator;
